import { TENANT_CODE } from 'libs/constants';
import { getPackageApiBaseUrl } from 'libs/env';
import { getIdToken } from 'libs/liff-api';
import { ApiClient, PointCardLinkParams } from './api-client';

/**
 * スマートレシートの連携を行う
 *
 * - 連携成功ページへ
 *     - 200 : 連携に成功した場合
 * - 入力フォームでエラーメッセージのトーストを表示
 *     - 400 : 入力項目に不備がある場合
 *     - 500 : Packageでエラーが発生した場合
 *     - 503 : スマレシAPIでエラーが発生した場合
 * - エラーページ (/not-found) へ
 *     - 404 : 設定上通常の遷移ではありえない
 *
 * @return {Promise<boolean>} 連携に成功した場合はtrue。入力項目に問題がある場合はfalse
 * @throws {import('libs/features-api').NetworkError} FetchAPIが失敗した場合
 * @throws {import('libs/features-api').ResponseError} APIの問い合わせ結果が「失敗」の場合
 */
export const callPointCardLink = async ({
  accountId,
  plainPassword
}: PointCardLinkParams): Promise<boolean> => {
  const client = new ApiClient({
    packageHost: getPackageApiBaseUrl(),
    tenantCode: TENANT_CODE,
    liffIdToken: getIdToken({ throwable: true })
  });

  return await client.callPointCardLinkUrl({ accountId, plainPassword });
};
